import MyBagRecommendation from './MyBagRecommendation';

export default MyBagRecommendation;
